/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const INTEREST_SERIES_DEFINITION_SLICE_NAME = 'interetsSeriesDefinition';
